import { render, staticRenderFns } from "./DetailTNAExperiential.vue?vue&type=template&id=5798bc2b&scoped=true"
import script from "./DetailTNAExperiential.vue?vue&type=script&lang=js"
export * from "./DetailTNAExperiential.vue?vue&type=script&lang=js"
import style0 from "./DetailTNAExperiential.vue?vue&type=style&index=0&id=5798bc2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5798bc2b",
  null
  
)

export default component.exports